import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';

import getToken from './getToken';
import { UseInvoiceAuthError, UseInvoiceAuthHasToken, UseInvoiceAuthLoading } from './types';

const useInvoiceAuth = () => {
  const context = useVSFContext();
  const loading = sharedRef(false, `useInvoiceAuth/loading`);
  const error = sharedRef(null, `useInvoiceAuth/error`);
  const hasToken = sharedRef(false, `useInvoiceAuth/hasToken`);

  const refs = {
    loading,
    error,
    hasToken,
  };

  return {
    getToken: getToken(context, refs),
    clearToken: () => context.$xero.api.clearToken(),
    hasToken: computed<UseInvoiceAuthHasToken>(() => hasToken.value),
    loading: computed<UseInvoiceAuthLoading>(() => loading.value),
    error: computed<UseInvoiceAuthError>(() => error.value),
  };
};

export default useInvoiceAuth;
